import { useContext, useEffect, useState } from "react"
import { MainContext } from "./controllers/main"
import Error from "./views/public/error"
import Loading from "./views/public/loading"
import Onboarding from "./views/public/onboarding"
import Main from "./views/private/main"
import AvatarSelection from "./views/public/avatarSelection"
import { t } from "i18next"

const App = () => {
  const {
    loading,
    signUpError,
    userError,
    viewOnboarding,
    viewAvatarSelection,
  } = useContext(MainContext)

  // loading progress
  const [progress, setProgress] = useState<number>(0)

  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        setProgress(20)
      }, 50)
    }
  }, [])

  if (signUpError || userError) {
    return (
      <Error
        modules={[
          { name: "Authentication", error: signUpError },
          { name: "User", error: userError },
        ]}
      />
    )
  }

  if (loading) {
    return (
      <Loading
        title={t("retrieving_user_information")}
        determinate
        progress={progress}
      />
    )
  }

  if (viewOnboarding) {
    return <Onboarding />
  }

  if (viewAvatarSelection) {
    return <AvatarSelection />
  }

  return <Main />
}

export default App
